/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutIndividualDeliveryRequestBodyTypename = "PutIndividualDeliveryRequestBody" as const;

/**
 *
 * @export
 * @interface PutIndividualDeliveryRequestBody
 */
export interface PutIndividualDeliveryRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutIndividualDeliveryRequestBody
   */
  inquiryUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PutIndividualDeliveryRequestBody
   */
  providerType: PutIndividualDeliveryRequestBodyProviderTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PutIndividualDeliveryRequestBody
   */
  trackingNumber: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutIndividualDeliveryRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PutIndividualDeliveryRequestBodyProviderTypeEnum {
  Yamato = "yamato",
  Sagawa = "sagawa",
  YuPack = "yu-pack",
}

export function PutIndividualDeliveryRequestBodyFromJSON(json: any): PutIndividualDeliveryRequestBody {
  return PutIndividualDeliveryRequestBodyFromJSONTyped(json, false);
}

export function PutIndividualDeliveryRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutIndividualDeliveryRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutIndividualDeliveryRequestBodyTypename,

    inquiryUrl: !exists(json, "inquiry_url") ? undefined : json["inquiry_url"],
    providerType: json["provider_type"],
    trackingNumber: json["tracking_number"],
  };
}

export function PutIndividualDeliveryRequestBodyToJSON(object?: PutIndividualDeliveryRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    inquiry_url: value.inquiryUrl,
    provider_type: value.providerType,
    tracking_number: value.trackingNumber,
  };
}
